// Keyword filters kept on the server (/api/v1/filters). Pleroma drops the
// posts of irreversible ones itself; the others are for the client to
// apply, which it does with the same matching as its own word filters.

// the places a post is shown in, named as the filter contexts
export const PLACES = ['home', 'public', 'notifications', 'thread']

// the place of a timeline: home and lists are 'home', the public and
// hashtag timelines 'public'; profiles, bookmarks and the like have none
const TIMELINE_PLACES = {
  friends: 'home',
  list: 'home',
  public: 'public',
  publicAndExternal: 'public',
  bubble: 'public',
  tag: 'public',
}

export const filterPlaceFor = (timelineName) =>
  TIMELINE_PLACES[timelineName] ?? null

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// no letter, combining mark, number or underscore
const EDGE = '[^\\p{L}\\p{M}\\p{N}_]'

// server filters that apply in a place, in the local filter shape
export const asLocalFilters = (filters, place) =>
  filters
    .filter((f) => f.context.includes(place))
    .map((f, index) => ({
      name: f.phrase,
      type: f.whole_word ? 'regexp' : 'word',
      value: f.whole_word
        ? `(^|${EDGE})${escapeRegExp(f.phrase)}($|${EDGE})`
        : f.phrase,
      unicode: f.whole_word,
      hide: f.irreversible,
      enabled: true,
      expires: f.expires_at ? Date.parse(f.expires_at) : null,
      order: -1 - index,
    }))
